module.exports = __webpack_public_path__ + "static/media-page-2a977a94f18f943b91c8965b9a10079a.png";